/**
 * Mutación para modificar los datos del producto activo en el visualizador.
 *
 * @param {*} state
 * @param {*} next: nuevos datos.
 * @author Fernando Claros
 */
export function setProductVisualized(state, next) {
    state.productVisualized = next
}

/**
 * Mutación para control el estado de carga.
 *
 * @param {*} state
 * @param {*} next: nuevos datos.
 * @author Fernando Claros
 */
export function setLoading(state, next) {
    state.loading = next
}

/**
 * Mutación para control el estado de descarga de una adjunto.
 *
 * @param {*} state
 * @param {*} next: nuevos datos.
 * @author Fernando Claros
 */
export function setLoadingDownloadAttachment(state, next) {
    state.loadingDownloadAttachment = next
}